export const MIN_TEMP = -25;
export const MAX_TEMP = 25;